exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photon-button{background:none;border:none;margin:0;padding:0;background-color:var(--grey-90-a10);padding:0 8px;border-radius:2px}.photon-button:hover{background-color:var(--grey-90-a20)}.photon-button:hover:active{background-color:var(--grey-90-a30)}.photon-button::-moz-focus-inner{border:none}.photon-button:-moz-focusring{outline:1px dotted #000;-moz-outline-radius:2px}.photon-button-ghost{background-color:transparent;height:32px;width:32px}.photon-button-ghost:hover{background-color:var(--grey-90-a10)}.photon-button-ghost:hover:active{background-color:var(--grey-90-a20)}", ""]);

// exports
